import Index from '@/components/Index'
import About from '@/components/About'
import Contact from '@/components/Contact'
import Instruction from '@/components/Instruction'

const routers = [{
		path: '/',
		component: Index,
	}, {
		path: '/about',
		component: About,
	}, {
		path: '/instructions',
		component: Instruction,
	}, {
		path: '/contact',
		component: Contact,
	}
	// alias:'/jspang'
]

export default routers



// WEBPACK FOOTER //
// ./src/routers.js